module.exports = __webpack_public_path__ + "static/img/example1.f73d62d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/chainmanage/image/example1.jpg
// module id = 719
// module chunks = 0